module.exports = __webpack_public_path__ + "static/co-fes-logo-dark@3x-74203e5e5e574203eb76eae13efa29ea.png";